<template>
  <div class="wrapper">
    <header-title
      title="دليل التصنيف المعياري"
      titlePrevious="الرئيسية"
      color="#164e63"
    />
    <div class="main-content general-activities">
      <div class="container">
        <div class="mt-5">
          <h4>المقدمة :</h4>
          <p>
            نتيجة تنامي عمل المنظمات غير الحكومية بشكل واضح، وتنوع أشكالها
            ومهامها في خدمة القطاعات التي تستهدفها، إضافة إلى توسع مجاالت عملها،
            األمر الذي أدى إلى ضرورة تأطير نشاطاتها بشكل يسهم من حيث لالرتقاء
            بأداء المنظمات غير الحكومية على النتيجة الى تركيز الجهود األهلية ضمن
            اختصاصات محددة، سعياً وتحقيقاً اختالف أنواعها، بهدف منع ازدواجية
            العمل وتداخل االختصاصات للتكامل الضروري ضمن النطاق الجغرافي الواحد،
            من خالل معرفة الفئات المستهدفة من قبل تلك المنظمات. حيث يعّرف
            التصنيف لغةً بأنه التمييز بين األمور، وترتيبها وتجميعها على حسب درجة
            التشابه بينها، أو فصلها عن بعضها بالنظر لدرجات تباينها
          </p>
        </div>
        <br />
        <div>
          <h4>أهمية التصنيف المعياري للمنظمات غير الحكومية في:</h4>
          <ul>
            <li class="list_style_disc">
              تركيز الجهود األهلية ضمن قطاعات محددة، رغبة برفع جودة خدماتها،
              الناتجة عن الخبرة في مجال محدد.
            </li>
            <li class="list_style_disc">
              اعتماد معايير تقييم أداء، تتناسب مع نوع كل مجموعة من المجموعات
              التي تنضوي تحتها المنظمات غير الحكومية.
            </li>
            <li class="list_style_disc">
              تسهيل تحليل واقع الخدمات المقدمة في كل قطاع من القطاعات.
            </li>
            <li class="list_style_disc">
              تأطير الجوانب القانونية التي تحكم عمل كل نوع من أنواع المنظمات غير
              الحكومية.
            </li>
          </ul>
        </div>
        <br />
        <div>
          <h4>تعريف عام بالدليل:</h4>
          <p>
            يحتوي هذا الدليل على شرح الخطوات التفصيلية الواجب اتباعها من قبل
            المنظمات غير الحكومية، بهدف تحديد للتصنيف المعياري المعتمد، وفق آلية
            ترميز محددة. تصنيفها وفقاً
          </p>
        </div>
        <div class="d-flex justify-content-end my-2">
          <b-button variant="primary">
            <download-icon
              size="1.5x"
              class="custom-class mr-1"
            ></download-icon>
            <a href="/files/circulars.pdf" download class="download_button"
              >تحميل دليل التصنيف المعياري</a
            >
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DownloadIcon } from "vue-feather-icons";
import { BButton } from "bootstrap-vue";
import HeaderTitle from "../../components/HeaderTitle.vue";

export default {
  components: {
    DownloadIcon,
    BButton,
    HeaderTitle,
  },
};
</script>

<style scoped>
.download_button {
  color: #ffffff;
  margin-right: 5px;
}
.title {
  font-family: Almarai, sans-serif;
  font-weight: 400;
  letter-spacing: 0.00735em;
  line-height: 2.5rem;
  color: #82868b;
}
p,
ul {
  text-align: justify;
  font-size: 16px;
  line-height: 28px;
  font-family: "Lato", sans-serif;
  margin-top: 15px;
  margin-left: 12px;
  margin-right: 12px;
}
h2 {
  margin-bottom: 1rem;
  font-size: 32px;
}
</style>
